(function () {
  'use strict';

  d3.chart('Plot').extend('Line', {
    initialize : function (options) {
      var plot = this;
      options = options || {};

      plot.layers = {
        series : plot.viz.append('g').classed('series', true)
      };

      plot.line = d3.svg.line()
          .x(function (d) { return plot.x(plot.fn.x(d)); })
          .y(function (d) { return plot.y(plot.fn.y(d)); });

      plot.layer('series', plot.layers.series, {
        dataBind : function (data) {
          return this.selectAll('path')
              .data(data.series);
        },
        insert : function () {
          return this.insert('path');
        },
        events : {
          merge : function () {
            this
                .attr('d', plot.withSeries(function () {
                  return plot.line(plot.data.data);
                }))
                .style('stroke', function (series) {
                  return plot.color(series.name);
                });
          },
          exit : function () {
            this.remove();
          }
        }
      });

      plot
          .on('change:clip', function () {
            plot.layers.series.selectAll('path')
                .style('clip-path', 'url(#' + plot.clipperId + ')');
          });
    },
    transform : function (data) {
      var plot = this;

      if (data !== plot.data) {
        plot.setData(data);

        var yDomain = ['min', 'max'].map(function (minOrMax) {
          var setValue = plot.yDomain[minOrMax];
          return !_.isUndefined(setValue) ? setValue :
              d3[minOrMax](data.series.map(plot.withSeries(function () {
                return d3[minOrMax](data.data.map(plot.fn.y));
              })));
        });

        plot.setYDomain(yDomain);
      }

      return data;
    }
  });

})();
